module.exports = __webpack_public_path__ + "static/media/logo.f9d70060.png";